import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './StatisticPage.module.scss'
import { Layout, PageHeader, UnvButton, Icon } from 'components'
import AllDataPercentage from './components/AllDataPercentage/AllDataPercentage'

import PieChartsLine from './components/PieChartsLine/PieChartsLine'
import DocumentStatusCards from './components/DocumentStatusCards/DocumentStatusCards'

import { useDispatch, useSelector } from 'react-redux'
import { getAllStatisticCompany } from 'service/StatisticService'
import { setAllStatistic } from 'store/slices/StatisticSlice'
import { useNavigate } from 'react-router-dom'
import userInfo from 'utils/userInfo'

const AllStatisticPage = () => {
  const { t } = useTranslation('common')
  const [data, setData] = useState()
  const dispatch = useDispatch()
  const user = userInfo()
  const [selectedEmp, setSelectedEmp] = useState(user.userId)

  const getData = async () => {
    try {
      let response = await getAllStatisticCompany(selectedEmp, data)

      dispatch(
        setAllStatistic({
          allStatistic: response.data,
        }),
      )
    } catch (error) {
    }
  }
  useEffect(() => {
    getData()
  }, [selectedEmp])
  const statisticDatas = useSelector((state) => state.statistic.allStatistic)
  // Wave 4: useNavigate() не принимает аргументов. Получаем функцию навигации.
  const navigate = useNavigate()

  return (
    <Layout>
      <div className={styles.statistic_wrapper}>
        <PageHeader
          icon={<Icon name="chart" size={28} />}
          title={t('statisticPage.company_statistics')}
          subtitle={t('auto.allstatisticpage.subtitle', 'Сводная статистика по компании')}
          actions={
            <UnvButton variant="ghost" iconLeft="arrow-left" onClick={() => navigate(-1)}>
              {t('statisticPage.back')}
            </UnvButton>
          }
        />
        <div className={styles.statistic_blured_block}>
          <div className={styles.block_top_section}>
            <AllDataPercentage data={statisticDatas.AllDataPercentage} />
            <PieChartsLine data={statisticDatas.PieChartsLine} />
          </div>
          <div className={styles.block_bottom_section}>
            <DocumentStatusCards
              is_all_statistic={true}
              dataLastActions={statisticDatas.LastActionCard}
              data={statisticDatas.DocumentStatusCards}
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default AllStatisticPage
